<template>
  <div>
    <navBar></navBar>
    <div class="content-bg">
      {{ activeinfo?.title }}
    </div>
    <div class="content-form">
      <van-form @submit="onSubmit" :show-error-message="false">
        <van-field v-model="form.customerName" name="customerName" label="姓名" placeholder="请输入姓名"
          :rules="[{ required: true, message: '请输入姓名' }]" required />
        <van-field readonly clickable name="picker" :value="gender" label="性别" placeholder="请选择性别"
          @click="showPicker = true" :rules="[{ required: true, message: '请选择性别' }]" required />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
        </van-popup>
        <van-field v-model="form.position" name="position" label="职务" placeholder="请输入职务"
          :rules="[{ required: true, message: '请输入职务' }]" required />
        <van-field readonly clickable name="picker" :value="companyTypeName" label="单位类型" placeholder="请选择单位类型"
          @click="companyTypeCode = true" :rules="[{ required: true, message: '请选择单位类型' }]" required />
        <van-popup v-model="companyTypeCode" position="bottom">
          <van-picker show-toolbar :columns="unitTypeOptions" @confirm="oncompanyTypeCode"
            @cancel="companyTypeCode = false" />
        </van-popup>
        <van-field v-model="companyFirstName" name="position" label="单位名称" @blur="inputname"
          :placeholder="'请输入' + placeholderone" :rules="[{ required: true, message: '请输入' + placeholderone }]"
          required />
        <van-field v-if="UnitInput.length > 1" v-model="companysecondName" name="position" label="" @blur="inputname"
          :placeholder="'请输入' + placeholdertwo" :rules="[{ required: true, message: '请输入' + placeholdertwo }]" />
        <van-field v-if="UnitInput.length > 2" v-model="companythirdName" name="position" label="" @blur="inputname"
          :placeholder="'请输入' + placeholderthree" :rules="[{ required: true, message: '请输入' + placeholderthree }]" />
        <van-field readonly clickable name="picker" :value="industryname" label="行业类型" placeholder="请选择行业类型"
          @click="industry = true" :rules="[{ required: true, message: '请选择行业类型' }]" required />
        <van-popup v-model="industry" position="bottom">
          <van-picker show-toolbar :columns="industryTypeOptions" @confirm="onindustry" @cancel="industry = false" />
        </van-popup>

        <!-- <van-field readonly clickable name="picker" :value="isOverseasvalue" placeholder="点击选择"
          @click="showisOverseas = true" :rules="[{ required: true, message: '请选择地址' }]" required />
        <van-popup v-model="showisOverseas" position="bottom">
          <van-picker show-toolbar :columns="isOverseasOptions" @confirm="OnisOverseas"
            @cancel="showisOverseas = false" />
        </van-popup> -->
        <van-field readonly clickable name="picker" :value="form.country" label="地址" placeholder="点击选择"
          @click="showCountry = true" />
        <van-popup v-model="showCountry" position="bottom">
          <van-picker show-toolbar :columns="countryoptions" @confirm="OnCountry" @cancel="showCountry = false" />
        </van-popup>
        <van-field v-if="form.country == '中国'" readonly clickable name="area" :value="provincevalue" label=""
          placeholder="点击选择省市区" @click="showArea = true" />
        <van-popup v-model="showArea" position="bottom">
          <van-area :area-list="provinceLists" @confirm="onProvince" @cancel="showArea = false" />
        </van-popup>
        <van-field v-model="form.address" name="address" label="" placeholder="请输入地址"
          :rules="[{ required: true, message: '请输入地址' }]" />
        <van-field v-model="form.jobTitle" name="position" label="职称" placeholder="请输入职称" />
        <van-field v-model="form.phone" name="position" label="手机号" placeholder="请输入手机号"
          :rules="[{ required: true, message: '请输入手机号' }]" required type="number" />
        <van-field v-model="form.email" name="position" label="邮箱" placeholder="请输入邮箱"
          :rules="[{ required: true, message: '请输入邮箱' }]" required />
        <!-- :rules="[{ required: true, message: '请输入邮箱' }]" -->
        <van-field v-model="form.wechat" name="position" label="微信号" placeholder="请输入微信号" />
        <!-- :rules="[{ required: true, message: '请输入微信号' }]" -->
        <van-field v-model="form.remark" name="position" label="备注详情" placeholder="请输入备注详情" rows="2" type="textarea" />

        <!-- 印尼展显示 -->
        <div v-if="activeinfo?.classifyName == '印尼展'">
          <van-field name="radio" label="申请面积" class="radio">
            <template #input>
              <van-radio-group v-model="form.applyAreaType" direction="horizontal">
                <van-radio name="standard">标准展位(9㎡/个)</van-radio>
                <van-radio name="ground">光地（单位:㎡）</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-if="form.applyAreaType == 'standard'" v-model="form.applyAreaNumber" name="applyAreaNumber" label="" placeholder="请输入数量"
            type="number" />
          <van-field v-if="form.applyAreaType == 'ground'" v-model="form.applyArea" name="applyArea" label="" placeholder="请输入平方米" type="number" />
          <van-field v-model="form.firstChoose" name="firstChoose" label="第一选择" placeholder="请输入" />
          <van-field v-model="form.secondChoose" name="secondChoose" label="第二选择" placeholder="请输入" />
          <van-field v-model="form.thirdChoose" name="thirdChoose" label="第三选择" placeholder="请输入" />
          <van-field v-model="form.cost" name="cost" label="费用" maxlength="10" placeholder="请输入" type="number" />
          <van-field v-model="form.companyNameEN" name="companyNameEN" label="单位名称--英文" placeholder="请输入" />
          <van-field v-model="form.companyAddressEN" name="companyAddressEN" label="单位地址--英文" placeholder="请输入" />
          <van-field v-model="form.showpiece" name="showpiece" label="展品名称(中英文)" placeholder="请输入" />
          <van-field v-model="form.amount" name="amount" maxlength="10" label="金额" placeholder="请输入" type="number" />
          <van-field v-model="form.bigAmount" name="bigAmount" label="大写金额" placeholder="请输入" />
          <van-field v-model="form.tel" name="tel" label="电话" placeholder="请输入" />
          <van-field v-model="form.fax" name="fax" maxlength="30" label="传真" placeholder="请输入" type="number" />
          <van-field v-model="form.website" name="website" label="网址" placeholder="请输入" />
        </div>

        <div v-for="(item, index) in list" :key="index">
          <div v-if="item.types != 'common'">
            <van-field v-if="item.fieldType == 'text'" v-model="form.properties[item.fieldCode]" :name="item.fieldCode"
              :label="item.fieldsName" :placeholder="item.fieldPlaceholder" :rules="[
        {
          required: item.fieldRequired,
          message: '请输入' + item.fieldPlaceholder,
        },
      ]" :required="item.fieldRequired" />
            <van-field v-if="item.fieldType == 'textarea'" v-model="form.properties[item.fieldCode]"
              :name="item.fieldCode" :label="item.fieldsName" :placeholder="item.fieldPlaceholder" :rules="[
        {
          required: item.fieldRequired,
          message: '请输入' + item.fieldPlaceholder,
        },
      ]" :required="item.fieldRequired" rows="2" type="textarea" />
            <van-field v-if="item.fieldType == 'number'" v-model="form.properties[item.fieldCode]"
              :name="item.fieldCode" :label="item.fieldsName" :placeholder="item.fieldPlaceholder" :rules="[
        {
          required: item.fieldRequired,
          message: '请输入' + item.fieldPlaceholder,
        },
      ]" :required="item.fieldRequired" type="number" />
          </div>
          <!-- <van-field
          name="area"
          :value="provincevalue"
          label="地址"
          placeholder="点击选择省市区"
          @click="showArea = true"
          :rules="[{ required: true, message: '请选择地址' }]"
          required
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="provinceLists"
            @confirm="onProvince"
            @cancel="showArea = false"
          />
        </van-popup>
          <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="value"
            label="时间选择"
            placeholder="点击选择时间"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
              type="time"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup> -->
        </div>
        <div style="margin: 16px -22px 0; width: calc(100% + 44px)">
          <!-- <van-button class="submit" round block type="info" @click="onSubmit"
          >提交报名</van-button
        > -->
          <van-button class="submit" round block type="info" native-type="submit">提交报名</van-button>
        </div>
      </van-form>
      <van-overlay :show="isshow" z-index="999">
        <van-loading style="top: 50%;" />
      </van-overlay>
      <!-- @click="isshow = false" -->
    </div>
  </div>
</template>

<script>
import navBar from "@/components/navBar.vue";
import { listEventMetadatas, saveregister, listEventuserdatas } from "@/api/register";
import { eventInfoDetail, preAddCustomer, getAllArea } from "@/api/home/index";
import { AreaCode } from "@/components/OverseasCountries";
export default {
  components: {
    navBar,
  },
  data() {
    return {
      AreaCode,
      id: "",
      columns: ["男", "女"],
      showPicker: false,
      list: [],
      form: {
        customerName: null,
        gender: null,
        position: null,
        companyTypeCode: null,
        companyTypeDesc: null,
        phone: null,
        email: null,
        wechat: null,
        remark: null,
        provinceId: null,
        cityId: null,
        areaId: null,
        industry: null,
        properties: {},
        // 印尼展
        applyAreaNumber: null,
        applyArea: null,
        firstChoose: null,
        secondChoose: null,
        thirdChoose: null,
        cost: null,
        companyNameEN: null,
        companyAddressEN: null,
        showpiece: null,
        amount: null,
        bigAmount: null,
        isOverseas: null,
        jobTitle: null,
        country: '中国',
        tel: null,
        fax: null,
        website: null,
        applyAreaType: 'standard'
      },
      // 回显的信息
      gender: null,
      companyTypeName: null,
      industryname: null,
      activeinfo: null,
      // 行业类型数据
      industry: false,
      industryTypeDatas: [],
      industryTypeOptions: [],
      // 单位类型数据
      companyTypeCode: false,
      unitTypeDatas: [],
      unitTypeOptions: [],
      // 省份
      provinceLists: [],
      provincevalue: null,
      showArea: false,
      // 是否省外
      showisOverseas: false,
      isOverseasvalue: '境内',
      isOverseasOptions: ['境内', '境外'],
      // 行业类型名称
      UnitInput: [],
      placeholderone: "",
      placeholdertwo: "",
      placeholderthree: "",
      companyFirstName: null,
      companysecondName: null,
      companythirdName: null,
      isshow: false,
      eventuserdatas: {},
      showCountry: false,
      countryoptions: [],
      sources: null,
    };
  },
  methods: {
    // 预添加数据
    preAddCustomerApi() {
      preAddCustomer().then((res) => {
        // console.log(res);
        this.unitTypeDatas = res.companyType;
        res.companyType.forEach((item) => {
          this.unitTypeOptions.push(item.dictDataName);
        });
        this.industryTypeDatas = res.industryType;
        res.industryType.forEach((item) => {
          this.industryTypeOptions.push(item.dictDataName);
        });
        // this.sourceChannelOptions = res.sourceChannel;

        // this.customerTypeOptions = res.customerType;
        // this.sexTypeOptions = res.sex;

        // if (
        //   this.form.companyTypeCode != null &&
        //   this.form.companyTypeCode !== "****"
        // ) {
        //   this.ChangeUnitType(this.form.companyTypeCode);
        // }
      });
    },
    // // 获取省
    // getProvinceOption() {
    //   getAreaProvince().then((res) => {
    //     this.provinceOption = res;
    //   });
    // },
    onSubmit() {
      // console.log("submit", this.form);
      this.isshow = true;
      saveregister({ eventId: this.id, ...this.form, sources: '二维码' })
        .then((res) => {
          console.log(res);
          this.isshow = false;
          this.$toast("报名成功");
          this.$router.go(-1);
        })
        .catch((e) => {
          this.$toast(e.message);
        });
    },
    onConfirm(value) {
      this.gender = value;
      if (value == "男") {
        this.form.gender = 1;
      } else if (value == "女") {
        this.form.gender = 2;
      }
      this.showPicker = false;
    },
    oncompanyTypeCode(value) {
      // console.log(value);
      this.companyTypeName = value;
      this.form.companyTypeDesc = null;
      this.companyFirstName = null;
      this.companysecondName = null;
      this.companythirdName = null;
      this.unitTypeDatas.forEach((item) => {
        if (item.dictDataName === value) {
          this.form.companyTypeCode = item.dictDataCode;
          this.UnitInput = item.comments.split(";");
          this.placeholderone = this.UnitInput[0];
          this.placeholdertwo = this.UnitInput[1];
          this.placeholderthree = this.UnitInput[2];
        }
      });
      // console.log(111,this.UnitInput);
      // console.log(this.unitTypeDatas)
      this.companyTypeCode = false;
    },
    onindustry(value) {
      this.industryname = value;
      this.industryTypeDatas.forEach((item) => {
        if (item.dictDataName == value) {
          this.form.industry = item.dictDataCode;
        }
      });
      this.industry = false;
    },
    onProvince(value) {
      console.log(value);
      this.provincevalue =
        value[0].name + "/" + value[1].name + "/" + value[2].name;
      this.form.provinceId = this.provinceLists.all_code[value[0].code];
      this.form.cityId = this.provinceLists.all_code[value[1].code];
      this.form.areaId = this.provinceLists.all_code[value[2].code];
      this.showArea = false;
    },
    inputname() {
      if (this.companyFirstName != null) {
        this.form.companyTypeDesc = this.form.companyFirstName;
      }
      if (this.companysecondName != null) {
        this.form.companyTypeDesc =
          this.companyFirstName + ";" + this.companysecondName;
      }
      if (this.companythirdName != null) {
        this.form.companyTypeDesc =
          this.companyFirstName +
          ";" +
          this.companysecondName +
          ";" +
          this.companythirdName;
      }
      console.log(this.form.companyTypeDesc);
    },
    getCustomTable() {
      listEventMetadatas({
        eventId: this.id,
        types: "eventInfo",
      }).then((res) => {
        // console.log(res);
        this.list = res;
        res.forEach((item) => {
          // this.form[item.fieldCode] = null;
          if (!(item.fieldCode in this.form)) {
            this.$set(this.form, item.fieldCode, null);
          }
        });
      });
    },
    getavtive() {
      const route = this.$route;
      eventInfoDetail(this.id, route).then((res) => {
        // console.log(res);
        this.activeinfo = res;
      });
    },
    getAllAreas() {
      getAllArea().then((res) => {
        // console.log(res);
        this.provinceLists = res;
      });
    },
    OnisOverseas(value) {
      // console.log(value);
      if (value == "境内") {
        this.form.isOverseas = false
      }
      if (value == "境外") {
        this.form.isOverseas = true
      }
      this.showisOverseas = false;
    },
    getEventuserdatas() {
      listEventuserdatas({ eventId: this.id }).then((res) => {
        console.log(res);
        this.eventuserdatas = res;
      });
    },
    OnCountry(val) {
      this.form.country = val
      this.showCountry = false;
    },
    showedit(row) {
      const id = [1, , 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 31, 32]
      return id.includes(row.id)
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.sources = this.$route.query.sources;
    this.getCustomTable();
    this.getavtive();
    this.preAddCustomerApi();
    this.getAllAreas();
    this.getEventuserdatas()

    this.AreaCode.map((item) => {
      this.countryoptions.push(item.name);
    })
    // console.log(this.countryoptions);
  },
  // computed: {
  //   fieldValue(fieldName) {
  //     return this.form[fieldName];
  //   },
  // },
  watch: {
    eventuserdatas(newval) {
      if (newval != '') {
        // 姓名
        this.form.customerName = newval.customerName
        // 性别
        if (newval.gender && newval.gender == 1) {
          this.gender = "男";
          this.form.gender = "1";
        } else if (newval.gender && newval.gender == 2) {
          this.gender = "女";
          this.form.gender = "2";
        }
        // 职务
        this.form.position = newval.position
        // 单位类型
        this.oncompanyTypeCode(newval.companyTypeName)
        // this.companyTypeName = newval.companyTypeName
        this.form.companyTypeCode = newval.companyTypeCode
        // 单位名称
        if (newval.companyTypeDesc) {
          this.form.companyTypeDesc = newval.companyTypeDesc;
          let companyTypeDesc = newval.companyTypeDesc.split(";");
          // console.log('监听',companyTypeDesc);
          if (companyTypeDesc.length > 1) {
            this.companyFirstName = companyTypeDesc[0];
            this.companysecondName = companyTypeDesc[1];
          } else if (companyTypeDesc.length > 2) {
            this.companyFirstName = companyTypeDesc[0];
            this.companySecondName = companyTypeDesc[1];
            this.companyThirdName = companyTypeDesc[2];
          }
        }
        // 行业类型
        this.onindustry(newval.industryTip)
        // 地址
        if (newval.isOverseas) {
          this.OnisOverseas('境外')
          this.isOverseasvalue = '境外'
        } else {
          this.OnisOverseas('境内')
          this.isOverseasvalue = '境内'
        }
        // 省市区

        this.form.address = newval.address;
        // 职称
        this.form.jobTitle = newval.jobTitle;
        // 手机号
        this.form.phone = newval.phone;
        // 邮箱
        this.form.email = newval.email;
        // 微信号
        this.form.wechat = newval.wechat;
        this.form.remark = newval.remark;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.content-bg {
  margin-top: 46px;
  height: 195px;
  background: url(../../assets/images/regist-bg.png) no-repeat center center;
  background-size: cover;
  color: #fff;
  padding: 32px 40px 0;
  font-size: 18px;
  line-height: 32px;
}

.content-form {
  margin: 0 18px;
  margin-top: -110px;
  background: #fff;
  border-radius: 20px;
  padding: 15px 22px 22px;

  .van-cell {
    display: block;
    overflow: visible;

    :deep .van-field__value {
      background-color: #f6f6f6;
      border-radius: 20px;
      padding: 10px 20px;
      margin: 10px -20px 0;
    }

    :deep .van-field__label {
      width: 150px;
    }
  }

  .van-cell::after {
    border: none;
  }

  .submit {
    background: #2553e2;
  }
}
.radio{
  :deep .van-field__value{
    padding: 10px 10px !important;

  }
  .van-radio-group{
    font-size: 14px;
    flex-wrap: nowrap;
  }
  :deep .van-radio__icon{
    font-size: 16px;
  }
}
</style>